import { render, staticRenderFns } from "./HistoricoAvaliacao.vue?vue&type=template&id=40ebbd63&"
import script from "./HistoricoAvaliacao.vue?vue&type=script&lang=js&"
export * from "./HistoricoAvaliacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports